var a = Object.defineProperty, Z = Object.defineProperties;
var u = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var T = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var f = (m, r, e) => r in m ? a(m, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : m[r] = e, i = (m, r) => {
  for (var e in r || (r = {}))
    T.call(r, e) && f(m, e, r[e]);
  if (t)
    for (var e of t(r))
      c.call(r, e) && f(m, e, r[e]);
  return m;
}, n = (m, r) => Z(m, u(r));
import { format as g } from "../format/index.js";
import { toZonedTime as l } from "../toZonedTime/index.js";
function b(m, r, e, o) {
  return o = n(i({}, o), {
    timeZone: r,
    originalDate: m
  }), g(l(m, r, { timeZone: o.timeZone }), e, o);
}
export {
  b as formatInTimeZone
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns-tz@3.2.0_date-fns@3.6.0/~/date-fns-tz/dist/esm/formatInTimeZone/index.js
// module id = 1335
// module chunks = 41